.gridSpacing {
  margin-bottom: 16px;
}

.playScaleButton {
  margin-left: 8px;
}

.intervalGrid {
  margin-bottom: 16px;
}

.intervalCell {
  padding: 8px;
  text-align: center;
}

.chordGrid {
  margin-bottom: 16px;
}

.chordButtonWrapper {
  display: flex;
  align-items: center;
}

.chordButton {
  min-width: 60px;
  margin: 4px;
  text-transform: none;
}

.circleOfFifthsGrid {
  justify-content: center;
  display: flex;
}

.circleOfFifthsContainer {
  width: 100%;
  height: auto;
  max-width: 40vh;
  max-height: 40vh;
  display: flex;
  aspect-ratio: 1 / 1;
}

.divider {
  margin-top: 16px;
  margin-bottom: 16px;
}

.selectedChordSection {
  margin-bottom: 16px;
}

.flexCenter {
  display: flex;
  align-items: center;
}

.playChordButton {
  margin-left: 8px;
}

.backToScaleButton {
  margin-left: 16px;
}

.tabsSection {
  margin-bottom: 16px;
}

.tabContent {
  margin-top: 16px;
}
